export default __webpack_public_path__ + "static/media/structure2.0f076565.jpg";